<template>
    <div id="paper-root">
      <a-layout theme="light">
        <a-layout-header>
          <a-row id="paper-header">
            <a-col :span="10">
              <span @click="paperDescVisible=true"><a-icon v-if="paperInfo.paperDesc" type="question-circle" /> {{paperInfo.paperName}}</span>
            </a-col>
            <a-col :span="10">
              <span>{{$t('exam.timeLimit')}}：{{paperInfo.timeLimit}}</span>
              <a-divider type="vertical"/>
              <span>{{$t('exam.totalScore')}}:{{paperInfo.totalScore}}</span>
            </a-col>
          </a-row>
        </a-layout-header>
        <a-layout>
          <a-layout-sider :style="{ overflowY: 'auto' }">
            <a-card class="question-index">
              <a-row>
                <div v-for="(q, i) in paperQuestion" :key="i">
                  <a-col v-if="q.itemType==0 && q.questionSection" @click="jumpQuestion(i)" class="question-section" :span="24">{{ q.questionSection }}</a-col>
                  <a-col v-else :span="6">
                    <a-tag  @click="jumpQuestion(i)">{{ getQuestionIndex(i) }}</a-tag>
                  </a-col>
                </div>
              </a-row>
            </a-card>
          </a-layout-sider>
          <a-layout-content
            :style="{ minHeight: '80vh', height: 'calc(100vh - ' + heightOffset + 'px', overflow: 'auto' }"
          >
            <a-card class="paper-content" :bordered="false">
              <div v-for="(q, qi) in paperQuestion" :key="qi">
                <!-- 大标题 -->
                <div v-if="q.itemType==0" class="question-section">
                  <h2>{{ q.questionSection }}</h2>
                </div>
                <a-card v-else class="question-card" :id="'q-' + qi">
                  <a-row>
                    <!-- 题干 -->
                    <a-col>
                      <div class="question-stem">
                        <span>{{$t('exam.questionIndex',{index:qi+1, points:q.questionScore})}}</span>
                        <Voice :text="q.voiceText"/>
                        <a-divider type="vertical"></a-divider>
                        <div v-if="q.questionType != 4" v-html="q.questionStem"></div>
                      </div>
                      <div v-if="q.questionType == 4" :id="'question-stem-' + q.id"></div>
                    </a-col>
                    <a-divider />
                    <a-col>
                      <!-- 单选 -->
                      <a-radio-group v-if="q.questionType == 1">
                        <a-radio v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                          <span class="question-letter">{{ index2letter(oi) }}
                          </span>
                          <div class="question-options-content">
                            <div class="option" v-html="o.item"></div>
                          </div>
                        </a-radio>
                      </a-radio-group>
                      <!-- 多选 -->
                      <a-checkbox-group v-if="q.questionType == 2">
                        <a-checkbox v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                          <span class="question-letter">{{ index2letter(oi) }}
                          </span>
                          <div class="question-options-content">
                            <div class="option" v-html="o.item"></div>
                          </div>
                        </a-checkbox>
                      </a-checkbox-group>
                      <!-- 判断题 -->
                      <a-radio-group v-if="q.questionType == 3">
                        <a-radio value="true"><span class="question-letter">{{ index2letter(0) }}</span>{{$t('exam.right')}}</a-radio>
                        <a-radio value="false"><span class="question-letter">{{ index2letter(1) }}</span>{{$t('exam.wrong')}}</a-radio>
                      </a-radio-group>
                      <!-- 填空题 -->
                      <!-- 已改为虚拟DOM，直接在题干的下划线展示答案 -->
                      <!-- <div v-if="q.questionType == 4">
                        <a-input
                          readOnly
                          v-for="oi in q.questionOptions.fillGapNum"
                          :key="oi"
                          :placeholder="'第' + oi + '空回答'"
                        />
                      </div> -->
                      <!-- 主观题 阅读分析-->
                      <div v-if="q.questionType == 5 || q.questionType == 6">
                        <a-textarea
                          :auto-size="{ minRows: 5, maxRows: 20 }"
                          :placeholder="$t('exam.answerArex')"
                        ></a-textarea>
                      </div>
  
                      <!-- 编程题 -->
                      <!-- OJ编程题 -->
                      <div v-if="q.questionType == 7 || q.questionType == 8">
                        <a-button type="primary" size="large" @click="openEditor(q, false)">{{$t('exam.viewTemplate')}}</a-button>
                        <a-divider type="vertical" v-if="q.questionAnalysis"></a-divider>
                        <a-button type="primary" size="large" v-if="q.questionAnalysis" @click="openEditor(q, true)">{{$t('exam.viewTemplate')}}</a-button>
                      </div>
                    </a-col>
                  </a-row>
                  <a-divider />
                  <a-row>
                    <a-col :span="8">
                      <p>{{$t('exam.answer')}}:
                        <!-- <span>{{paperQuestion[qi]['questionAnswer']}}</span> -->
                        <span>{{answer2Text(paperQuestion[qi])}}</span>
                      </p>
                    </a-col>
                  </a-row>
                </a-card>
              </div>
            </a-card>
          </a-layout-content>
        </a-layout>
      </a-layout>
      <a-modal
        :width="'800px'"
        :visible="paperDescVisible"
        :title="$t('exam.paperDesc')"
        :destroyOnClose="true"
        :footer="null"
        @cancel="paperDescVisible=false"
      >
        <div v-html="paperInfo.paperDesc"></div>
      </a-modal>
      <a-modal :width="'100%'" :visible="editorVisible" :maskClosable="false" :dialogStyle="{top: 0}" :bodyStyle="{padding:0}"
        :destroyOnClose="true" :footer="null" @cancel="editorVisible=false">
        <a-icon slot="closeIcon" type="close-circle" theme="twoTone" style="font-size: 30px;line-height: 70px;"/>
        <div slot="title">
          <a-row>
             <a-col :span="8">
              <span>{{currentQuestionInfo.questionName}}</span>
             </a-col>
            <a-col :span="8">
              <a-button type="primary" v-if="currentQuestionInfo.questionType!=8" @click="viewQuestionStem(currentQuestionInfo)">{{$t('exam.viewQuestionStem')}}</a-button>
            </a-col>
          </a-row>
          </div>
        <iframe :src="editorUrl" id="player" frameborder="0" width="100%" style="height:calc(100vh - 70px);"
          scrolling="no"></iframe>
      </a-modal>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import Voice from '@/components/tools/Voice'
  import  { examMixins } from '@/utils/examMixins'
  import { getAction, postAction } from '@/api/manage'
  export default {
    name: 'PaperPreview',
    mixins: [examMixins],
    components: {
      Voice
    },
    data() {
      return {
        heightOffset: 0,
        paperId: '',
        paperInfo: {}, //试卷信息
        paperQuestion: [], //已经过转换的题目信息
        questionSections:{},//题目分类信息
        paperDescVisible: false, //试卷介绍是否可见
        editorVisible: false,
        editorUrl: '',
      }
    },
    created() {
      this.paperId = this.$route.query.id
      this.getPaperInfo(this.paperId)
    },
    mounted() {
      let paperHeader = document.getElementById('paper-header')
      this.heightOffset = paperHeader.clientHeight + paperHeader.offsetTop
    },
    methods: {
      //获取答卷
      getPaperInfo(id) {
        this.paperQuestion = []
        return getAction(`/teaching/teachingPaper/getPaperPreview?paperId=${id}`).then((res) => {
          if (res.success && res.result != null) {
            this.paperInfo = res.result.paper
            let questions = res.result.question
            this.parseQuestion(questions)
          } else {
            this.$message.error(res.message)
          }
        })
      },
      //解析题目
      parseQuestion(questions) {
        for (let qi in questions) {
          let q = questions[qi]
          console.log("parse question:", q);
          //兼容旧数据，生成大题标题
          if (q.questionSection && q.itemType != 0) {
              this.paperQuestion.push({
                  itemType: 0,
                  questionSection: q.questionSection
              })
          }
          if (q.questionOptions != null) {
            q.questionOptions = JSON.parse(q.questionOptions)
          }
          q.voiceText = this.getQuestionVoice(q)
          this.paperQuestion.push(q)
          //渲染填空题dom
          if(q.questionType == 4){
            this.renderGapFillingStemDom(q, qi)
          }      
        }
      },
    },
  }
  </script>
  
  <style lang="less" scoped>
  /deep/p{
    margin-bottom: .5em;
  }
  .ant-layout {
    width: 100%;
    background: transparent;
  }
  .ant-layout-header {
    background: #fff;
  }
  .ant-layout-sider {
    background: #fff;
    text-align: center;
  }
  .remain-time {
    color: red;
    font-size: 20px;
  }
  .question-index {
    text-align: left;
    .question-section {
      margin: 10px 0px;
    }
    .ant-tag {
      height: 30px;
      width: 30px;
      font-size: 14px;
      line-height: 28px;
      margin-top: 4px;
    }
  }
  .paper-content {
    .question-card {
      margin-bottom: 20px;
    }
    .question-section {
      margin: 10px;
    }
    .question-stem {
      width: 100%;
      max-height: 500px;
      overflow: auto;
      span,
      > div {
        display: inline-block;
        vertical-align: top;
      }
    }
    .ant-radio-wrapper,.ant-checkbox-wrapper {
      display: block !important;
      margin-left: 0px;
      margin-bottom: .5em;
    }
    .question-options-content {
      display: inline-block;
    }
    .question-letter{
      vertical-align: top;
      margin-right: 10px;
    }
    /deep/.ant-checkbox, /deep/.ant-radio{
      vertical-align: top;
      top: 0.2em;
    }
  }
  </style>